"use client"

import { useState } from "react"
import { useNavigate } from "react-router-dom"
import { useLanguage } from "../../contexts/LanguageContext";

export default function CompleteProjectModal({ isOpen, onClose, projectId }) {
  const [rating, setRating] = useState(0)
  const [comment, setComment] = useState("")
  const { t } = useLanguage();
  const navigate = useNavigate()

  if (!isOpen) return null

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch(`http://localhost:5000/complete-project/${projectId}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ rating, comment }),
      });
      const data = await response.json();
      if (data.success) { onClose(); navigate("/BHome"); }
      else console.error("Error completing project:", data.error);
    } catch (error) { console.error("Error completing project:", error); }
  }

  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', backdropFilter: 'blur(6px)', display: 'flex', alignItems: 'flex-start', justifyContent: 'center', paddingTop: '80px', zIndex: 50 }}>
      <div style={{ background: 'var(--bg-card)', border: '1px solid var(--border-glass)', borderRadius: '20px', padding: '28px', width: '400px', maxWidth: '90vw', position: 'relative' }}>
        <div style={{ height: '3px', position: 'absolute', top: 0, left: 0, right: 0, borderRadius: '20px 20px 0 0', background: 'linear-gradient(90deg, #34d399, #10b981)' }} />
        <div style={{ textAlign: 'center', marginTop: '8px' }}>
          <h3 style={{ fontSize: '1.1rem', fontWeight: 700, color: 'var(--text-primary)', fontFamily: 'var(--font-display)', marginBottom: '16px' }}>{t('completeProject')}</h3>
          <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
            <div style={{ marginBottom: '14px' }}>
              <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', display: 'block', marginBottom: '8px' }}>{t('rating')}</label>
              <div style={{ display: 'flex', gap: '4px', justifyContent: 'center' }}>
                {[1, 2, 3, 4, 5].map((star) => (
                  <span key={star} onClick={() => setRating(star)} style={{ fontSize: '1.6rem', cursor: 'pointer', color: star <= rating ? '#fbbf24' : 'var(--border-subtle)', transition: 'color 0.15s' }}>★</span>
                ))}
              </div>
            </div>
            <div style={{ marginBottom: '14px' }}>
              <label style={{ fontSize: '0.8rem', fontWeight: 600, color: 'var(--text-secondary)', display: 'block', marginBottom: '4px' }}>{t('comment')}</label>
              <textarea rows="3" required value={comment} onChange={(e) => setComment(e.target.value)}
                style={{ width: '100%', padding: '10px 14px', background: 'var(--bg-elevated)', border: '1px solid var(--border-subtle)', borderRadius: '10px', color: 'var(--text-primary)', fontSize: '0.85rem', outline: 'none', resize: 'vertical' }}
                onFocus={e => e.target.style.borderColor = '#34d399'} onBlur={e => e.target.style.borderColor = 'var(--border-subtle)'} />
            </div>
            <div style={{ display: 'grid', gap: '8px' }}>
              <button type="button" onClick={onClose} style={{ padding: '12px', borderRadius: '12px', border: '1px solid var(--border-glass)', background: 'var(--bg-elevated)', color: 'var(--text-secondary)', fontWeight: 600, cursor: 'pointer', fontSize: '0.85rem' }}>{t('close')}</button>
              <button type="submit" style={{ padding: '12px', borderRadius: '12px', border: 'none', background: 'linear-gradient(135deg, #34d399, #10b981)', color: '#fff', fontWeight: 600, cursor: 'pointer', fontSize: '0.85rem' }}>{t('submit')}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  )
}

